import React, {useEffect} from 'react';
import CarrierForm from '@assets/pages/Settings/Carriers/CarrierForm/CarrierForm';
import useInput from '@assets/hooks/useInput';

const CarrierCreate = ({input, validations}) => {
  const [carrier, handleChangeData] = useInput(input.current);

  useEffect(() => {
    input.current = carrier;
  }, [carrier]);

  return (
    <div className="HCC-Carrier_Create">
      <CarrierForm {...{carrier, handleChangeData, validations}} />
    </div>
  );
};

export default CarrierCreate;
